import React from 'react';

import { Box, IconButton } from '@mui/material';
import dompurify from 'dompurify';

import { AIPrompterCloseIcon } from '../../../NewUI/Components/Icons';
import { classes } from '../styles';

import type { MouseEvent } from 'react';

export const ResponseMessage = ({ id, message }: { id: string; message: string }) => {
  const handleClose = (e: MouseEvent<HTMLElement>) => {
    e.preventDefault();
    const reactComponentRoot = document.getElementById(id) as HTMLElement;
    const responseMessageContainer = reactComponentRoot?.parentElement
      ?.nextElementSibling as HTMLElement;
    if (responseMessageContainer) {
      responseMessageContainer.style.display = 'none';
      reactComponentRoot.innerHTML = 'Get Felix AI’s feedback on my answer';
    }
  };

  return (
    <Box key={id} sx={classes.responseMessageContainer}>
      <IconButton onClick={handleClose} style={classes.closeIcon}>
        <AIPrompterCloseIcon />
      </IconButton>
      <Box
        sx={classes.responseMessageContent}
        dangerouslySetInnerHTML={{
          __html: dompurify.sanitize(message.replace(/\n\n/g, '<br />'))
        }}
      />
    </Box>
  );
};
